import styled from 'styled-components';

export const StyledFooter = styled.footer`
  display: flex;
  background-color: #1e1e1e;
  justify-content: center;
  padding: .4rem;
`;